var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-button",on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('ui-button',{attrs:{"icon":_vm.icon}}),_c('span',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }